import initMixin from './init'
import calculateMixin from './calculate'
import scrollMixin from './scroll'
import paintMixin from './paint'
import eventsMixin from './events'

export default [initMixin, scrollMixin, calculateMixin, paintMixin, eventsMixin]



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/mixins/index.js